export function range(start: number, end: number): number[] {
  if (start < 0 || end < 0 || start > end) {
    return [];
  }
  return Array(end - start + 1)
    .fill(1)
    .map((_, index) => start + index);
}

export function constrain(number: number, lowerBound: number, upperBound: number) {
  return Math.min(Math.max(number, lowerBound), upperBound);
}
